import { Image } from "@kobalte/core";
import { mdiChevronRight } from "@mdi/js";
import { type JSX, Show, splitProps } from "solid-js";
import { TranslationField } from "~/components/TranslationField";
import { Group } from "~/components/ui/group";
import { Icon } from "~/components/ui/icon";
import { Text } from "~/components/ui/text";
import { cn } from "~/util/utils";
import type { ListItemLink } from "../../../types/item";
import type { ListAppearance } from "../../../types/list";

interface LinkItemProps extends JSX.HTMLAttributes<HTMLAnchorElement> {
	link: ListItemLink;
	appreance: ListAppearance;
}

export function ListLinkItem(props: LinkItemProps) {
	const [local, other] = splitProps(props, ["link", "appreance", "class"]);

	return (
		<TranslationField key={local.link.target}>
			{(target) => (
				<a
					class={cn(
						"border-b border-gray-200 flex items-center justify-between p-4 gap-x-8 min-w-min",
						"hover:bg-gray-50 transition-colors",
						"active:bg-gray-100",
						local.class,
					)}
					href={target()}
					target="_blank"
					{...other}
				>
					<Group
						class="w-full truncate flex"
						justify="between"
					>
						<div class="justify-between flex flex-wrap flex-1 gap-2">
							<TranslationField key={local.link.title}>
								{(title) => <Text class="line-clamp-3">{title()}</Text>}
							</TranslationField>
							<Text class="text-xs text-gray-600">{target()}</Text>
						</div>
						<Show
							when={local.link.trailingIcon}
							fallback={
								<Icon
									class="fill-gray-400 float-end"
									path={mdiChevronRight}
									size="md"
								/>
							}
						>
							<Image.Root>
								<Image.Img
									class="fill-gray-400 float-end size-6 object-contain"
									src={local.link.trailingIcon}
									alt=""
								/>
								<Image.Fallback>
									<Icon
										class="fill-gray-400 float-end"
										path={mdiChevronRight}
										size="md"
									/>
								</Image.Fallback>
							</Image.Root>
						</Show>
					</Group>
				</a>
			)}
		</TranslationField>
	);
}
